import { useEffect, useState } from "react";
import { useUiStore } from "../store/uiStore.js";

/**
 * 行高必须来自 token（--row-height），而不是组件里写死 32。
 *
 * 这是「密度切换」与「虚拟化」的交汇点：改 data-density 后行高变量变化，
 * 虚拟化必须立刻用新行高重算，否则会错位。所以这里既读 computed style，
 * 又订阅 density 变化重新读取。
 */
export function readRowHeightPx(fallback = 32): number {
  if (typeof window === "undefined") return fallback;
  const raw = window.getComputedStyle(document.documentElement).getPropertyValue("--row-height").trim();
  const parsed = Number.parseFloat(raw);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
}

export function useRowHeight(): number {
  const density = useUiStore((state) => state.density);
  const [rowHeight, setRowHeight] = useState<number>(() => readRowHeightPx());

  useEffect(() => {
    // 等属性生效后再读，确保读到的是新密度的行高
    const frame = window.requestAnimationFrame(() => setRowHeight(readRowHeightPx()));
    return () => window.cancelAnimationFrame(frame);
  }, [density]);

  return rowHeight;
}
